import { useDeliveryZoneMsToken } from 'hooks';
import { GRAPHQL_CLIENT_NAMES } from 'service/constants';
import { City, QueryCitiesArgs } from '../../types/generated';
import { useQuery } from '../../utils';
import { QueryHookResponse } from '../../types/internal';
import { citiesListQuery } from '../../queries/deliveryZones';

type useFetchCitiesListType = (args: QueryCitiesArgs) => QueryHookResponse<City>;

const useFetchCitiesList: useFetchCitiesListType = ({ countryId }) => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return useQuery<City>({
    query: citiesListQuery,
    variables: { countryId },
    clientName: GRAPHQL_CLIENT_NAMES.DELIVERY_ZONES,
    requestHeaders: { token: deliveryZoneMsToken },
    handler: (res: any) => res.cities,
    config: { revalidateOnMount: true },
  });
};

export default useFetchCitiesList;
